import { render } from "./BillViewer.vue?vue&type=template&id=4fd6c1dc&scoped=true"
import script from "./BillViewer.vue?vue&type=script&lang=js"
export * from "./BillViewer.vue?vue&type=script&lang=js"

import "./BillViewer.vue?vue&type=style&index=0&id=4fd6c1dc&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd6c1dc"]])

export default __exports__